import { render, staticRenderFns } from "./ProductPriceControl.vue?vue&type=template&id=2ea0d116&"
import script from "./ProductPriceControl.vue?vue&type=script&lang=js&"
export * from "./ProductPriceControl.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceControl.vue?vue&type=style&index=0&id=2ea0d116&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports